module.exports = __webpack_public_path__ + "img/Badge_Sustainability_2025.7946111d.jpg";